import React, { useEffect, useState } from "react";
import {
  Grid,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  List,
  Tabs,
  Tab,
  Box,
  Typography,
  CircularProgress,
  Collapse,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { getRecents } from "../store/ducks/duckRecents";

import ListItemRecent from "./ListItemRecent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      aria-labelledby={`a11y-tab-${index}`}
      hidden={value !== index}
      id={`a11y-tabpanel-${index}`}
      role="tabpanel"
      style={{ width: "100%" }}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
};

const useStyles = makeStyles((theme) => ({
  textItem: {
    //color: 'rgba(0, 0, 0, 0.54)',
    color: "rgba(37, 36, 35, 0.5)",
    "&:hover": {
      background: "white",
      color: "rgba(37, 36, 35, 1)",
      fontSize: theme.typography.pxToRem(17),
      boxShadow: "1px 1px 9px 1px #8888885e",
    },
  },
  star: {
    color: "rgb(218, 197, 0)",
    cursor: "pointer",
  },
  loadMore: {
    textAlign: "center",
    color: "rgba(37, 36, 35, 0.5)",
    "&:hover": {
      background: "white",
      color: "rgba(37, 36, 35, 1)",
      fontSize: theme.typography.pxToRem(17),
      boxShadow: "1px 1px 9px 1px #8888885e",
    },
  },
  noRecents: {
    textAlign: "center",
    color: "rgba(37, 36, 35, 0.5)",
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 55,
      width: "100%",
      backgroundColor: "rgba(1, 174, 78, 1)",
    },
    height: 4,
  },
  root: {
    marginTop: 20,
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "rgba(0, 0, 0, 0.67)",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&:focus": {
      opacity: 1,
      fontSize: theme.typography.pxToRem(17),
    },
    "&:selected": {
      opacity: 1,
      fontSize: theme.typography.pxToRem(17),
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const TabHome = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { data: recents, loading, totalCount } = useSelector((state) => state.recents);
  const paths = useSelector((state) => state.sidebar.paths);
  const [page, setPage] = useState(0);

  const [value, setValue] = React.useState(0);

  useEffect(() => {
    dispatch(getRecents(page));
  }, [dispatch, page]);

  const handleRedirect = (url) => (e) => {
    e.preventDefault();
    if (url) {
      history.push(url);
    }
  };

  const handleLoadMore = () => {
    setPage(page + 1);
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Collapse in={paths && !loading} timeout={{ appear: 2000, enter: 2000, exit: 2000 }}>
      <>
        <Grid container>
          <Grid item xs={12}>
            <StyledTabs aria-label="styled tabs example" value={value} onChange={handleChange}>
              <StyledTab label="Recent" />
            </StyledTabs>
          </Grid>
        </Grid>
        <Grid container>
          <TabPanel index={0} value={value}>
            <List aria-label="list-recents" component={"div"}>
              {paths && !loading && recents.length === 0 && (
                <ListItem alignItems="center" className={classes.noRecents}>
                  <ListItemText color="textPrimary" primary="You have not viewed pages recently" />
                </ListItem>
              )}
              {paths &&
                recents.map((r, i) => {
                  let date = moment.utc(r.date).local().format("DD/MM/YYYY  h:mm a");

                  let parts = r.resource.split("/");
                  let lastSegment = parts.pop() || parts.pop();

                  let id = parseInt(lastSegment);

                  if (!paths[id]) {
                    return null;
                  }

                  return (
                    <ListItemRecent
                      key={`List-Item-Recent-${i}`}
                      classes={classes}
                      date={date}
                      description={r.description}
                      handleClickPrimaryText={handleRedirect(r.resource)}
                      id={id}
                      number={i}
                      resource={r.resource}
                      textPrimary={paths && paths[id] ? paths[id] : ""}
                    />
                  );
                })}
              <Divider />
              {totalCount !== recents.length ? (
                <>
                  <ListItemButton
                    alignItems="center"
                    className={classes.loadMore}
                    onClick={handleLoadMore}
                  >
                    <ListItemIcon>
                      <ExpandMoreIcon />
                    </ListItemIcon>
                    <ListItemText color="textPrimary" primary="Load more" />
                    <ListItemIcon>{loading && <CircularProgress />}</ListItemIcon>
                  </ListItemButton>
                  <Divider />
                </>
              ) : null}
            </List>
          </TabPanel>
        </Grid>
      </>
    </Collapse>
  );
};

export default TabHome;
